import { render, staticRenderFns } from "./SituacaoCadastroModal.vue?vue&type=template&id=219686cd&scoped=true"
import script from "./SituacaoCadastroModal.vue?vue&type=script&lang=js"
export * from "./SituacaoCadastroModal.vue?vue&type=script&lang=js"
import style0 from "./SituacaoCadastroModal.vue?vue&type=style&index=0&id=219686cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219686cd",
  null
  
)

export default component.exports